<div class="container-fluid">
  <div class="d-flex flex-column flex-sm-row">
    <mat-form-field>
      <mat-icon matPrefix color="primary">search</mat-icon>
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Rechercher" />
    </mat-form-field>
    <mat-form-field class="ms-sm-3">
      <mat-label>Types</mat-label>
      <mat-select [(value)]="filterType" (valueChange)="updateDataFromFilters()">
        <mat-option>Tous</mat-option>
        <mat-option *ngFor="let type of availableTypes" [value]="type">{{typesDisplay[type]}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-slide-toggle (change)="toggleDisplayColumns()" [checked]="displayFullColumns" class="m-3">Afficher toutes
      colonnes</mat-slide-toggle>
  </div>
  <mat-divider></mat-divider>
  <div class="table-container">
    <div class="loading" *ngIf="isLoadingResults">
      <mat-spinner color="primary"></mat-spinner>
    </div>
    <table mat-table class="default" [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nom</th>
        <td mat-cell *matCellDef="let row" class="main">{{ row.name }} {{ row.prop.demo ? '(Mode
          Démo actif)' :
          '' }}</td>
      </ng-container>
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let row" class="mobile-inline mobile-separator">{{ row.type }}</td>
      </ng-container>
      <ng-container matColumnDef="ownerUserName">
        <th mat-header-cell *matHeaderCellDef>Propriétaire</th>
        <td mat-cell *matCellDef="let row">{{ row.owner }}</td>
      </ng-container>
      <ng-container matColumnDef="coOwnerUserName">
        <th mat-header-cell *matHeaderCellDef>Co-Propriétaire</th>
        <td mat-cell *matCellDef="let row" class="no-mobile">{{ row.coOwner }}</td>
      </ng-container>
      <ng-container matColumnDef="city">
        <th mat-header-cell *matHeaderCellDef>Ville</th>
        <td mat-cell *matCellDef="let row" class="mobile-inline mobile-separator">{{ row.prop.address ?
          row.prop.address.city : '' }}</td>
      </ng-container>
      <ng-container matColumnDef="eemoId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>EemoId</th>
        <td mat-cell *matCellDef="let row">{{ row.eemoId }}</td>
      </ng-container>
      <ng-container matColumnDef="certificationType">
        <th mat-header-cell *matHeaderCellDef>Certification</th>
        <td mat-cell *matCellDef="let row" class="no-mobile">{{ row.certificationType }}</td>
      </ng-container>
      <ng-container matColumnDef="certificationDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date certification</th>
        <td mat-cell *matCellDef="let row" class="no-mobile"> {{ row.prop.certificationDate | dateFormat }}</td>
      </ng-container>
      <ng-container matColumnDef="archived">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date certification</th>
        <td mat-cell *matCellDef="let row" class="no-mobile"> {{ row.prop.archived | booleanFormat }}</td>
      </ng-container>
      <ng-container matColumnDef="dateCreate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date création</th>
        <td mat-cell *matCellDef="let row" class="no-mobile">{{ row.prop.dateCreate | dateTimeFormat }}</td>
      </ng-container>
      <ng-container matColumnDef="dateUpdate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date mise à jour</th>
        <td mat-cell *matCellDef="let row" class="no-mobile">{{ row.prop.dateCreate | dateTimeFormat }}</td>
      </ng-container>
      <ng-container matColumnDef="uid">
        <th mat-header-cell *matHeaderCellDef>ID</th>
        <td mat-cell *matCellDef="let row">{{ row.uid }}</td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let row" class="mobile-double-actions">
          <button mat-icon-button [routerLink]="['/property', row.prop.uid]" appTooltip="Voir le bien">
            <mat-icon color="primary">remove_red_eye</mat-icon>
          </button>
          <button mat-icon-button [matMenuTriggerFor]="actions" [matMenuTriggerData]="{data:row}">
            <mat-icon>more_vert</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="row.demo ? 'is-demo' : ''">
      </tr>
    </table>

    <mat-paginator [length]="paging.length" [pageSize]="paging.pagingPageSize"
      [pageSizeOptions]="paging.pagingPageSizeOptions" showFirstLastButtons></mat-paginator>
  </div>
</div>


<mat-menu #actions="matMenu">
  <ng-template matMenuContent let-row="data">
    <ul class="menu-actions">
      <li>
        <a (click)="settings(row.prop)"><mat-icon color="primary">settings</mat-icon><span class="text">Paramétrer le
            bien</span></a>
      </li>
      <li *ngIf="!row.prop.certified">
        <a (click)="certify(row.prop)"><mat-icon color="primary">check_circle_outline</mat-icon><span
            class="text">Certifier le bien</span></a>
      </li>
      <li *ngIf="row.prop.certified && row.prop.certificationType!=='INHERITED'">
        <a (click)="certify(row.prop)"><mat-icon color="primary">update</mat-icon><span class="text">Renouveler la
            certification</span></a>
      </li>
      <li *ngIf="row.prop.certified && row.prop.certificationType!=='INHERITED'">
        <a (click)="printCertification(row.prop)"><mat-icon color="primary">print</mat-icon><span class="text">Imprimer
            les documents de certification</span></a>
      </li>
      <li>
        <a (click)="transfertOwnership(row.prop)"><mat-icon color="primary">transfer_within_a_station</mat-icon><span
            class="text">Transférer la propriété</span></a>
      </li>
      <li>
        <a (click)="manageCoOwner(row.prop)"><mat-icon color="primary">people_alt</mat-icon><span class="text">Gérer les
            co-propriétaires</span></a>
      </li>
      <!--<li *ngIf="row.prop.certified">
        <a (click)="actionService.copyPropVCardUrl(row.prop)"><mat-icon color="primary">content_copy</mat-icon><span
            class="text">Copier
            l'URL de la VCard</span></a>
      </li>-->
      <li *ngIf="row.prop.certified">
        <a (click)="actionService.copyPropNfcUrl(row.prop)"><mat-icon color="primary">content_copy</mat-icon><span
            class="text">Copier
            le lien NFC</span></a>
      </li>
      <li>
        <a (click)="confirmDelete(row.prop)">
          <mat-icon color="primary">delete_forever</mat-icon>
          <span class="text">Supprimer le bien</span>
        </a>
      </li>
    </ul>
  </ng-template>
</mat-menu>